import React, { useState } from 'react'
import classnames from 'classnames'
import ActionDropdown from '@SiteComponents/ActionDropdown'
import More from '@Images/projects_table_list_more.svg'

import {
  IElement,
  IDeleteElementPayload,
} from '@SiteModules/Element/types'

import './AssetRow.scss'

interface AssetRowProps {
  readonly index: number
  readonly element: IElement
  handleDeleteElement(payload: IDeleteElementPayload): void
}

const AssetRow: React.FC<AssetRowProps> = props => {
  const {
    index,
    element,
  } = props

  const {
    id,
    attributes,
  } = element

  const {
    title,
    size,
    createdAt,
    updatedAt,
    thumbnailUrl,
    projectIds,
  } = attributes

  const [showDropdown, setShowDropdown] = useState(false)

  const moreElementId = `asset_row_more_${id}`
  const classNameForClickOutsideListenerMoreDropdown = `AssetsTable__action-dropdown-element-${id}`
  const useInProjects = projectIds.length

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown)
  }

  const handleDeleteElement = () => {
    props.handleDeleteElement({ elementId: id, notifyAboutSuccess: true })
    setShowDropdown(false)
  }

  const renderThumbnail = () => {
    const shouldShowColoredThumbnail = thumbnailUrl.includes('thumbnail-icon.png') || !thumbnailUrl
    const indexOfFirstIntegerInId = id.search(/[0-9]/)
    const colorPicker = indexOfFirstIntegerInId === -1 ? 0 : id[indexOfFirstIntegerInId]

    return (
      <React.Fragment>
        {shouldShowColoredThumbnail ? (
          <div className={`AssetRow__thumbnail-placeholder AssetsTable__thumbnail-placeholder${colorPicker}`} />
        ) : (
          <div className="AssetRow__thumbnail-image-wrapper with-blur-small">
            <img
              className="AssetRow__thumbnail-image background-blur"
              src={thumbnailUrl}
              aria-hidden="true"
            />
            <img
              className="AssetRow__thumbnail-image foreground"
              src={thumbnailUrl}
              alt="Asset thumbnail"
            />
          </div>
        )}
      </React.Fragment>
    )
  }

  const renderTitle = () => {
    return (
      <div className="AssetRow__name">
        {title}
      </div>
    )
  }

  const actionDropdownList = (
    <ul>
      <li
        className="AssetsTable__action-dropdown-item"
        onClick={handleDeleteElement}
      >
        <div className="AssetsTable__action-dropdown-item-text">
          Delete asset
        </div>
      </li>
    </ul>
  )

  const renderActionDropdown = () => {
    return (
      <ActionDropdown
        showDropdown={showDropdown}
        dropdownList={actionDropdownList}
        classNamesForListContainer="AssetsTable__action-dropdown"
        classNameForClickOutsideListener={classNameForClickOutsideListenerMoreDropdown}
        classNameOfScrollContainer="AssetsTableList"
        idOfDropdownElement={moreElementId}
        idOfPortalContainer="assets"
        dropdownOffsetX={45}
        dropdownOffsetY={0}
        dropdownWidth={209} // same width as AssetsTable__action-dropdown
        setShowDropdown={setShowDropdown}
      />
    )
  }

  return (
    <tr
      className={classnames(
        { 'AssetRow__even': index % 2 === 0 },
        { 'AssetRow__uneven': index % 2 === 1 }
      )}
    >
      <td className="AssetsTableList__thumbnail-name AssetRow__thumbnail-name">
        <div className="AssetRow__thumbnail-name-wrapper">
          {renderThumbnail()}
          {renderTitle()}
        </div>
      </td>
      <td className="AssetsTableList__size AssetRow__size">
        {size}
      </td>
      <td className="AssetsTableList__imported AssetRow__imported">
        {createdAt}
      </td>
      <td className="AssetsTableList__edited AssetRow__edited">
        {updatedAt}
      </td>
      <td className="AssetsTableList__use-in-projects AssetRow__use-in-projects">
        {useInProjects === 1 ? '1 time' : `${useInProjects} times`}
      </td>
      <td className="AssetsTableList__more AssetRow__more">
        <div
          className={`AssetRow__more-wrapper ${classNameForClickOutsideListenerMoreDropdown}`}
          id={moreElementId}
        >
          <More
            onClick={toggleDropdown}
          />
          {showDropdown && renderActionDropdown()}
        </div>
      </td>
    </tr>
  )
}

export default AssetRow
